import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";
import Config from "src/Constants/Config";

const PageId = 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      if (currentPage === PageId) {
        videoRef.current.currentTime = 0;
        videoRef.current.play().catch((err) => console.warn("Error al reproducir el video:", err));
      } else {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  }, [currentPage]);

  return {
    showHeader: false,
    fullScreen: false,
    children: (
      <div style={{ top: 0, left: 0, position: "absolute", width: "var(--width--1920)", height: "var(--height-1080)" }}>
        <svg
          onClick={() => setCurrentPage(0)}
          xmlns="http://www.w3.org/2000/svg"
          style={{
            position: "absolute",
            top: "var(--height-10)",
            right: "var(--width-70)",
            zIndex: 1000000,
            width: "var(--width-60)",
            height: "var(--height-60)",
          }}
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 21C10.22 21 8.47991 20.4722 6.99987 19.4832C5.51983 18.4943 4.36628 17.0887 3.68509 15.4442C3.0039 13.7996 2.82567 11.99 3.17294 10.2442C3.5202 8.49836 4.37737 6.89472 5.63604 5.63604C6.89472 4.37737 8.49836 3.5202 10.2442 3.17294C11.99 2.82567 13.7996 3.0039 15.4442 3.68509C17.0887 4.36628 18.4943 5.51983 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C21 14.387 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.387 21 12 21ZM12 4.5C10.5166 4.5 9.0666 4.93987 7.83323 5.76398C6.59986 6.58809 5.63856 7.75943 5.07091 9.12988C4.50325 10.5003 4.35473 12.0083 4.64411 13.4632C4.9335 14.918 5.64781 16.2544 6.6967 17.3033C7.7456 18.3522 9.08197 19.0665 10.5368 19.3559C11.9917 19.6453 13.4997 19.4968 14.8701 18.9291C16.2406 18.3614 17.4119 17.4001 18.236 16.1668C19.0601 14.9334 19.5 13.4834 19.5 12C19.5 10.0109 18.7098 8.10323 17.3033 6.6967C15.8968 5.29018 13.9891 4.5 12 4.5Z"
            fill="#fff"
          />
          <path
            d="M9.00001 15.75C8.90147 15.7504 8.80383 15.7312 8.71282 15.6934C8.62181 15.6557 8.53926 15.6001 8.47001 15.53C8.32956 15.3893 8.25067 15.1987 8.25067 15C8.25067 14.8012 8.32956 14.6106 8.47001 14.47L14.47 8.46997C14.6122 8.33749 14.8002 8.26537 14.9945 8.26879C15.1888 8.27222 15.3742 8.35093 15.5116 8.48835C15.649 8.62576 15.7278 8.81115 15.7312 9.00545C15.7346 9.19975 15.6625 9.38779 15.53 9.52997L9.53001 15.53C9.46077 15.6001 9.37822 15.6557 9.2872 15.6934C9.19619 15.7312 9.09855 15.7504 9.00001 15.75Z"
            fill="#fff"
          />
          <path
            d="M15 15.75C14.9015 15.7504 14.8038 15.7312 14.7128 15.6934C14.6218 15.6557 14.5392 15.6001 14.47 15.53L8.47 9.52997C8.33752 9.38779 8.2654 9.19975 8.26882 9.00545C8.27225 8.81115 8.35097 8.62576 8.48838 8.48835C8.62579 8.35093 8.81118 8.27222 9.00548 8.26879C9.19978 8.26537 9.38782 8.33749 9.53 8.46997L15.53 14.47C15.6704 14.6106 15.7493 14.8012 15.7493 15C15.7493 15.1987 15.6704 15.3893 15.53 15.53C15.4608 15.6001 15.3782 15.6557 15.2872 15.6934C15.1962 15.7312 15.0985 15.7504 15 15.75Z"
            fill="#fff"
          />
        </svg>
        <video ref={videoRef} style={{ width: "98%", height: "98%" }} controls muted src={`${Config.BASE_URL}/videos/pega.mp4`}></video>
      </div>
    ),
  };
};

export default DATA;
